import { TypographyProps } from '@mui/material';
import React from 'react';

import { TitleMediumStyled } from './styles';

export const TitleMedium: React.FC<TypographyProps> = (props) => {
  return (
    <TitleMediumStyled variant="h1" {...props}>
      {props.children}
    </TitleMediumStyled>
  );
};
